import React, { Component } from 'react';
import { Form, Button, Icon } from 'antd';

export default class PropertyGridShell extends Component {

    state = {

    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
    }

    componentWillUnmount() {
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.children !== this.props.children || nextProps.title !== this.props.title;
    }

    render() {

        return (
            <div className="propertygrid-shell layout-v vstretch">
                {/* <div className="layout-h sub-title-container center">
                    <div className="primary-text sub-title fill text-nowrap">{this.props.title}</div>
                    <Button className="btn-close" onClick={e => this.props.onClose()} title={"返回"}><Icon type="close" /></Button>
                </div> */}
                <div className="fill layout-v" style={{ height: 'calc(100% - 34px)' }}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
